import { configStore } from '../data/configStore.js';

/**
 * 支持的语言
 */
export const SupportedLanguages = {
  ZH: 'zh',
  EN: 'en'
};

class I18n {
  constructor() {
    this.currentLang = SupportedLanguages.ZH;
    this.translations = {};
    this.listeners = [];
  }

  async init() {
    await configStore.init();
    this.translations = configStore.getI18n() || {};

    const savedLang = localStorage.getItem('fsm_language');
    if (savedLang && Object.values(SupportedLanguages).includes(savedLang)) {
      this.currentLang = savedLang;
    }
  }

  setLanguage(lang) {
    if (!Object.values(SupportedLanguages).includes(lang)) {
      console.warn(`Unsupported language: ${lang}`);
      return;
    }

    this.currentLang = lang;
    localStorage.setItem('fsm_language', lang);

    this.listeners.forEach((callback) => callback(lang));

    window.dispatchEvent(
      new CustomEvent('i18n:languagechanged', { detail: { lang } })
    );
  }

  getLanguage() {
    return this.currentLang;
  }

  t(key, params = {}) {
    const translations = this.translations[this.currentLang] || {};
    const fallbackTranslations = this.translations[SupportedLanguages.ZH] || {};

    let text = this._getNestedValue(translations, key);

    if (text === undefined) {
      text = this._getNestedValue(fallbackTranslations, key);
    }

    if (text === undefined) {
      return key;
    }

    return text.replace(/\{(\w+)\}/g, (match, paramKey) => {
      return params[paramKey] !== undefined ? String(params[paramKey]) : match;
    });
  }

  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((cb) => cb !== callback);
    };
  }

  _getNestedValue(obj, path) {
    const keys = path.split('.');
    let value = obj;
    for (const key of keys) {
      if (value === null || value === undefined) return undefined;
      value = value[key];
    }
    return value;
  }
}

export const i18n = new I18n();
